import { css } from 'emotion'

export const ButtonStyles = css``
